/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SetRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      set: this.store.findRecord('milestones/set', params.set_id),
      allSets: this.store.findAll('milestones/set'),
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
      milestones: this.store.query('milestones/milestone', {
        templateSetId: params.set_id,
      }),
      levels: this.store.query('milestones/level', {
        templateSetId: params.set_id,
      }),
      expectations: this.store.query('milestones/expectation', {
        templateSetId: params.set_id,
      }),
      subjects: this.store.query('goals/subject', { trackable: true }),
      goalCategories: this.store.findAll('goals/category'),
      pages: this.store.findAll('posts/page'),
      usageSets: this.store.findAll('schools/usage-set'),
    });
  }

  // Load the set's usage sets and milestone set template up front so
  // setupController can seed the controller from the loaded records
  // synchronously, rather than from their async relationship proxies.
  afterModel(model) {
    return Promise.all([model.set.usageSetIds, model.set.milestoneSetTemplate]);
  }

  setupController(controller, model) {
    let milestoneSets = model.milestoneSets
      .slice()
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    milestoneSets.unshift({
      label: 'Default Milestones',
      isDefault: true,
    });
    model.milestoneSets = milestoneSets;

    super.setupController(...arguments);

    let selectedMilestoneSet = model.set
      .belongsTo('milestoneSetTemplateId')
      .value();
    if (isEmpty(model.set.milestone_set_template_id)) {
      selectedMilestoneSet = milestoneSets.find((m) => m.isDefault);
    }
    controller.setProperties({
      selectedUsageSetsFilter: model.set.usageSetsArray.slice(),
      includeSubjectsWithLevels: true,
      selectedMilestoneSet,
    });
  }
}
